<template>
  <div>
    <div class="graph-modal-body">
      <div
        class="font-weight-bold mb-1"
        style="font-size: 15px"
      >
        {{ $t('workOrders.graphs.modalTitle') }}
      </div>
      <div
        class="text-muted"
        style="font-size: 12px"
      >
        {{ $t('workOrders.graphs.modalDescription') }}
      </div>
      <div class="graphic-list-freeze-wrapper">
        <v-list dense :class="{ 'grayed-out': freeze }">
          <Graphic
            v-for="graph in graphics"
            :key="graph.id"
            :graphic="graph"
            :graphicId="graph.id"
            :selectedGraphIds="selectedGraphIds"
            :workOrderGraph="true"
            @onSelect="onSelect"
            @updatedOpenedGraphs="updatedOpenedGraphs"
            @freezeAllGraphs="freezeAllGraphs"
          />
        </v-list>
        <div v-if="freeze" class="graphic-list-freeze-overlay">
          <v-progress-circular size="48" indeterminate color="primary" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Graphic from '@/components/graphics/Graphic';

export default {
    name: 'WorkOrderGraphForm',
    components: {
        Graphic,
    },
    data() {
        return {
            selectedGraphIds: [],
            selectedGraphs: [],
            freeze: false,
        };
    },
    computed: {
        ...mapGetters([
            'lang',
        ]),
        graphics() {
            return this.$store.getters.graphics;
        },
        hasSiteId() {
            return Boolean(this.$route.params.siteId);
        },
    },
    created() {
        this.getGraphic();
    },
    methods: {
        // On check/uncheck graph add/remove the graph Id to/from the array of selectedGraphIds
        onSelect({ graphicId, checked }) {
            if (checked) {
                if (!this.selectedGraphIds.includes(graphicId)) {
                    this.selectedGraphIds.push(graphicId);
                }
            } else {
                this.selectedGraphIds = this.selectedGraphIds.filter(id => id !== graphicId);
            }
        },
        async getGraphic() {
            const { siteId } = this.$route.params;
            this.$store.dispatch('getGraphics', siteId);
        },
        updatedOpenedGraphs(data) {
            if (!data || !data.graphicId) return;
            const idx = this.selectedGraphs.findIndex(item => item.graphicId === data.graphicId);
            if (idx !== -1) {
                this.selectedGraphs.splice(idx, 1, data);
            } else {
                this.selectedGraphs.push(data);
            }
            this.$emit('sendData', this.selectedGraphs);
        },
        freezeAllGraphs(freeze) {
            this.freeze = freeze;
        },
    },
};
</script>

<style scoped>
.graphic-list-freeze-wrapper {
  position: relative;
}
.graphic-list-freeze-overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  background: rgba(255,255,255,0.5);
}
.grayed-out {
  opacity: 0.5 !important;
  filter: grayscale(0.4) !important;
  pointer-events: none;
}
</style>


<style scoped>
.graph-modal-header {
  border-bottom: 1px solid #eee;
  padding: 8px 0 8px 0;
}
.graph-modal-title {
  font-style: italic;
  font-size: 15px;
  margin-left: 8px;
}
.graph-modal-body {
  padding: 12px 0 0 0;
}
.graph-name {
  font-weight: 500;
  font-size: 18px;
}
.text-muted {
  color: #888;
}
.svg-preview svg {
  width: 30px !important;
  height: 20px !important;
  display: block;
  margin: 0 auto;
  background: #f9f9f9;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  border: 1px solid green;
}
</style>
